"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProfissao = void 0;
var EProfissao;
(function (EProfissao) {
    EProfissao[EProfissao["Acompanhante"] = 0] = "Acompanhante";
    EProfissao[EProfissao["Adm."] = 1] = "Adm.";
    EProfissao[EProfissao["Agente de Seguran\u00E7a"] = 2] = "Agente de Seguran\u00E7a";
    EProfissao[EProfissao["Assistente Administrativo"] = 3] = "Assistente Administrativo";
    EProfissao[EProfissao["Assistente de Comunica\u00E7\u00E3o"] = 4] = "Assistente de Comunica\u00E7\u00E3o";
    EProfissao[EProfissao["Assistente de Dire\u00E7\u00E3o"] = 5] = "Assistente de Dire\u00E7\u00E3o";
    EProfissao[EProfissao["Assistente de Editor"] = 6] = "Assistente de Editor";
    EProfissao[EProfissao["Assistente de Inform\u00E1tica"] = 7] = "Assistente de Inform\u00E1tica";
    EProfissao[EProfissao["Assistente Educacional"] = 8] = "Assistente Educacional";
    EProfissao[EProfissao["Assistente Social"] = 9] = "Assistente Social";
    EProfissao[EProfissao["Atendente"] = 10] = "Atendente";
    EProfissao[EProfissao["Atendente de Ber\u00E7\u00E1rio"] = 11] = "Atendente de Ber\u00E7\u00E1rio";
    EProfissao[EProfissao["Aux. Coordena\u00E7\u00E3o"] = 12] = "Aux. Coordena\u00E7\u00E3o";
    EProfissao[EProfissao["Auxiliar Administrativo(a)"] = 13] = "Auxiliar Administrativo(a)";
    EProfissao[EProfissao["Auxiliar de Biblioteca"] = 14] = "Auxiliar de Biblioteca";
    EProfissao[EProfissao["Auxiliar de Classe"] = 15] = "Auxiliar de Classe";
    EProfissao[EProfissao["Auxiliar de Cozinha"] = 16] = "Auxiliar de Cozinha";
    EProfissao[EProfissao["Auxiliar de Manuten\u00E7\u00E3o"] = 17] = "Auxiliar de Manuten\u00E7\u00E3o";
    EProfissao[EProfissao["Auxiliar de Recep\u00E7\u00E3o"] = 18] = "Auxiliar de Recep\u00E7\u00E3o";
    EProfissao[EProfissao["Auxiliar de Sala"] = 19] = "Auxiliar de Sala";
    EProfissao[EProfissao["Auxiliar de Servi\u00E7os Gerais"] = 20] = "Auxiliar de Servi\u00E7os Gerais";
    EProfissao[EProfissao["Auxiliar de Tesouraria"] = 21] = "Auxiliar de Tesouraria";
    EProfissao[EProfissao["Auxiliar de Secretaria"] = 22] = "Auxiliar de Secretaria";
    EProfissao[EProfissao["Auxiliar Geral"] = 23] = "Auxiliar Geral";
    EProfissao[EProfissao["Auxiliar Pedag\u00F3gico"] = 24] = "Auxiliar Pedag\u00F3gico";
    EProfissao[EProfissao["Bibliotec\u00E1rio(a)"] = 25] = "Bibliotec\u00E1rio(a)";
    EProfissao[EProfissao["Consultor"] = 26] = "Consultor";
    EProfissao[EProfissao["Coordena\u00E7\u00E3o de Eventos"] = 27] = "Coordena\u00E7\u00E3o de Eventos";
    EProfissao[EProfissao["Coordena\u00E7\u00E3o de Marketing"] = 28] = "Coordena\u00E7\u00E3o de Marketing";
    EProfissao[EProfissao["Coordenador(a)"] = 29] = "Coordenador(a)";
    EProfissao[EProfissao["Coordenador(a) Pastoral Escolar"] = 30] = "Coordenador(a) Pastoral Escolar";
    EProfissao[EProfissao["Coordenador(a) Pedag\u00F3gico(a)"] = 31] = "Coordenador(a) Pedag\u00F3gico(a)";
    EProfissao[EProfissao["Cozinheiro(a)"] = 32] = "Cozinheiro(a)";
    EProfissao[EProfissao["Cuidador(a) de Idosos"] = 33] = "Cuidador(a) de Idosos";
    EProfissao[EProfissao["Departamento Pessoal"] = 34] = "Departamento Pessoal";
    EProfissao[EProfissao["Digitador(a)"] = 35] = "Digitador(a)";
    EProfissao[EProfissao["Diretor(a)"] = 36] = "Diretor(a)";
    EProfissao[EProfissao["Documentador(a)"] = 37] = "Documentador(a)";
    EProfissao[EProfissao["Encarregado de Manuten\u00E7\u00E3o"] = 38] = "Encarregado de Manuten\u00E7\u00E3o";
    EProfissao[EProfissao["Escritur\u00E1rio(a)"] = 39] = "Escritur\u00E1rio(a)";
    EProfissao[EProfissao["Estagi\u00E1rio"] = 40] = "Estagi\u00E1rio";
    EProfissao[EProfissao["Financeiro"] = 41] = "Financeiro";
    EProfissao[EProfissao["Fiscal de Sala"] = 42] = "Fiscal de Sala";
    EProfissao[EProfissao["Gerente"] = 43] = "Gerente";
    EProfissao[EProfissao["Inspetor(a)"] = 44] = "Inspetor(a)";
    EProfissao[EProfissao["Instrutor(a)"] = 45] = "Instrutor(a)";
    EProfissao[EProfissao["Instrutor(a) de Cursos Livres"] = 46] = "Instrutor(a) de Cursos Livres";
    EProfissao[EProfissao["Instrutor(a) Musical"] = 47] = "Instrutor(a) Musical";
    EProfissao[EProfissao["Manutencionista"] = 48] = "Manutencionista";
    EProfissao[EProfissao["Mecanografia"] = 49] = "Mecanografia";
    EProfissao[EProfissao["Menor Aprendiz"] = 50] = "Menor Aprendiz";
    EProfissao[EProfissao["Merendeiro(a)"] = 51] = "Merendeiro(a)";
    EProfissao[EProfissao["Monitor de P\u00E1tio"] = 52] = "Monitor de P\u00E1tio";
    EProfissao[EProfissao["Monitor(a)"] = 53] = "Monitor(a)";
    EProfissao[EProfissao["Monitor(a) Chefe"] = 54] = "Monitor(a) Chefe";
    EProfissao[EProfissao["Motorista"] = 55] = "Motorista";
    EProfissao[EProfissao["Nutricionista"] = 56] = "Nutricionista";
    EProfissao[EProfissao["Oficial de Servi\u00E7os Gerais"] = 57] = "Oficial de Servi\u00E7os Gerais";
    EProfissao[EProfissao["Orientador(a)"] = 58] = "Orientador(a)";
    EProfissao[EProfissao["Porteiro(a)"] = 59] = "Porteiro(a)";
    EProfissao[EProfissao["Professor(a) Auxiliar"] = 60] = "Professor(a) Auxiliar";
    EProfissao[EProfissao["Professor(a) Substituto(a)"] = 61] = "Professor(a) Substituto(a)";
    EProfissao[EProfissao["Professor(a)"] = 62] = "Professor(a)";
    EProfissao[EProfissao["Psic\u00F3logo(a)"] = 63] = "Psic\u00F3logo(a)";
    EProfissao[EProfissao["Psicomotricista"] = 64] = "Psicomotricista";
    EProfissao[EProfissao["Psicopedagogo(a)"] = 65] = "Psicopedagogo(a)";
    EProfissao[EProfissao["Recepcionista"] = 66] = "Recepcionista";
    EProfissao[EProfissao["RH"] = 67] = "RH";
    EProfissao[EProfissao["Secret\u00E1rio(a)"] = 68] = "Secret\u00E1rio(a)";
    EProfissao[EProfissao["Servente"] = 69] = "Servente";
    EProfissao[EProfissao["Servi\u00E7os de Limpeza"] = 70] = "Servi\u00E7os de Limpeza";
    EProfissao[EProfissao["Servi\u00E7os Externos"] = 71] = "Servi\u00E7os Externos";
    EProfissao[EProfissao["Servi\u00E7os Gerais"] = 72] = "Servi\u00E7os Gerais";
    EProfissao[EProfissao["Supervisor(a)"] = 73] = "Supervisor(a)";
    EProfissao[EProfissao["Suporte"] = 74] = "Suporte";
    EProfissao[EProfissao["T\u00E9cnico(a) Administrativo(a)"] = 75] = "T\u00E9cnico(a) Administrativo(a)";
    EProfissao[EProfissao["T\u00E9cnico em Inform\u00E1tica"] = 76] = "T\u00E9cnico em Inform\u00E1tica";
    EProfissao[EProfissao["Telefonista"] = 77] = "Telefonista";
    EProfissao[EProfissao["Tesoureiro(a)"] = 78] = "Tesoureiro(a)";
    EProfissao[EProfissao["Treinador(a)"] = 79] = "Treinador(a)";
    EProfissao[EProfissao["Vice-Diretor(a)"] = 80] = "Vice-Diretor(a)";
    EProfissao[EProfissao["Vigia"] = 81] = "Vigia";
    EProfissao[EProfissao["Web Designer"] = 82] = "Web Designer";
    EProfissao[EProfissao["Zelador(a)"] = 83] = "Zelador(a)";
})(EProfissao = exports.EProfissao || (exports.EProfissao = {}));
